import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Accommodation } from './components/Accommodation';
import { Activities } from './components/Activities';
import { Gallery } from './components/Gallery';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { AdminLogin, AdminDashboard } from './components/AdminPanel';
import { Toaster } from './components/ui/sonner';
import './App.css';

const HomePage = () => (
  <>
    <Navbar />
    <main>
      <Hero />
      <Accommodation />
      <Activities />
      <Gallery />
      <Contact />
    </main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
